import apiClient from './ApiClient';

/**
 * Perform login, store token in localStorage
 * @param {string} phone
 * @param {string} password
 */
export async function authenticate(phone, password) {
  const { data } = await apiClient.post('/auth/authenticate', { phone, password });
  // adjust property name if your backend differs
  const token = data.accessToken || data.token; 
  if (token) {
    localStorage.setItem('accessToken', token);
  }
  return data;
}